(() => {
  const PRODUCTISH_TYPES = new Set(['Product', 'Review', 'AggregateRating']);

  function collectTypes(node, types = []) {
    if (!node || typeof node !== 'object') return types;

    if (Array.isArray(node)) {
      node.forEach((item) => collectTypes(item, types));
      return types;
    }

    const type = node['@type'];
    if (typeof type === 'string') types.push(type);
    if (Array.isArray(type)) {
      type.forEach((item) => {
        if (typeof item === 'string') types.push(item);
      });
    }

    if (node['@graph']) collectTypes(node['@graph'], types);

    return types;
  }

  function parseJsonLd(script) {
    try {
      return JSON.parse(script.textContent || '');
    } catch (error) {
      return null;
    }
  }

  function isProductishScript(script) {
    if (script.dataset.hrrSchema === 'product') return false;

    const parsed = parseJsonLd(script);
    if (parsed) {
      return collectTypes(parsed).some((type) => PRODUCTISH_TYPES.has(type));
    }

    const text = script.textContent || '';
    return /"@type"\s*:\s*"(Product|Review|AggregateRating)"/i.test(text) || /"aggregateRating"\s*:/i.test(text);
  }

  function cleanStructuredData() {
    const pageType = window.hrrPageType;
    if (pageType !== 'product' && pageType !== 'collection') return;

    document.querySelectorAll('script[type="application/ld+json"]').forEach((script) => {
      if (isProductishScript(script)) {
        script.remove();
      }
    });
  }

  function startObserver() {
    if (!document.body) return;

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (
            node.nodeType === Node.ELEMENT_NODE
            && node.tagName === 'SCRIPT'
            && node.type === 'application/ld+json'
          ) {
            cleanStructuredData();
            return;
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      cleanStructuredData();
      startObserver();
    }, { once: true });
  } else {
    cleanStructuredData();
    startObserver();
  }
})();
